import { getDefaultZoomUI } from '../../../ThemeProvider';
import { getDynamicSemanticToken } from '../../../DesignSystem';
export function getDynamicThemeToken(theme) {
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        font: {
            family: typography.fontFamily
        },
        textDecoration: {
            default: {
                default: 'none',
                hover: 'underline',
                active: 'underline',
            },
            primary: {
                default: 'none',
                hover: 'underline',
                active: 'underline',
            },
            secondary: {
                default: 'underline',
                hover: 'underline',
                active: 'underline',
            },
            disabled: {
                default: 'none',
                hover: 'none',
                active: 'none',
            },
        },
        color: {
            default: {
                default: semantic.text.primary,
                hover: semantic.state.primary.hover,
                active: semantic.state.primary.press,
            },
            primary: {
                default: semantic.text.primary,
                hover: semantic.state.primary.hover,
                active: semantic.state.primary.press,
            },
            secondary: {
                default: semantic.text.stronger.neutral,
                hover: semantic.text.strong.neutral,
                active: semantic.text.neutral,
            },
            disabled: {
                default: semantic.state.disable,
                hover: semantic.state.disable,
                active: semantic.state.disable,
            },
        },
        focusVisible: {
            outline: `2px solid ${semantic.border.primary}`,
        },
    };
}
